// extracted by mini-css-extract-plugin
export default {"PendingQuotes":"pending-quotes_PendingQuotes__4Thg8","searchContainer":"pending-quotes_searchContainer__f5Pow","searchInput":"pending-quotes_searchInput__pkwtI"};